<!-- <div class="video-container">
  <video #videoPlayer autoplay loop muted>
    <source
      src="https://videos.pexels.com/video-files/1111420/1111420-hd_1920_1080_30fps.mp4"
      type="video/mp4"
    />
    Your browser does not support the video tag.
  </video>
  <div class="controls">
    <button class="play-pause-btn" (click)="togglePlayPause(videoPlayer)">
      {{ isPlaying ? "⏸" : "▶" }}
    </button>
  </div>
  <div class="overlay">
    <div class="overlay-text">
      <h1>Fresh & Tasty</h1>
      <p>Explore Delicious Cuisines Delivered to Your Doorstep</p>
    </div>
  </div>
</div> -->

<div class="video-container">
  <video #videoPlayer autoplay loop muted>
    <source
      src="https://videos.pexels.com/video-files/1111420/1111420-hd_1920_1080_30fps.mp4"
      type="video/mp4"
    />
    Your browser does not support the video tag.
  </video>
  <div class="overlay">
    <div class="overlay-text">
      <h1>Fresh & Tasty</h1>
      <p>Explore Delicious Cuisines Delivered to Your Doorstep</p>
    </div>
  </div>
  <div class="controls">
    <button class="play-pause-btn" (click)="togglePlayPause(videoPlayer)">
      {{ isPlaying ? "🔊" : "🔇" }}
    </button>
  </div>
</div>
<!--== Start Feature Area Wrapper ==-->
<div class="feature-area">
  <div class="container pb--0">
    <div class="row">
      <div class="col-12">
        <div class="feature-content-box">
          <div class="feature-box-wrap">
            <div class="col-item">
              <div class="feature-icon-box">
                <div class="inner-content">
                  <div class="icon-box">
                    <img
                      class="icon-img"
                      src="../../../assets/img/icons/1.webp"
                      width="55"
                      height="41"
                      alt="Icon-HasTech"
                    />
                  </div>
                  <div class="content">
                    <h5 class="title">Free Home Delivary</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-item">
              <div class="feature-icon-box">
                <div class="inner-content">
                  <div class="icon-box">
                    <img
                      class="icon-img"
                      src="../../../assets/img/icons/2.webp"
                      width="35"
                      height="41"
                      alt="Icon-HasTech"
                    />
                  </div>
                  <div class="content">
                    <h5 class="title">Secure Payment</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-item">
              <div class="feature-icon-box">
                <div class="inner-content">
                  <div class="icon-box">
                    <img
                      class="icon-img"
                      src="../../../assets/img/icons/3.webp"
                      width="33"
                      height="41"
                      alt="Icon-HasTech"
                    />
                  </div>
                  <div class="content">
                    <h5 class="title">Order Discount</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-item">
              <div class="feature-icon-box">
                <div class="inner-content">
                  <div class="icon-box">
                    <img
                      class="icon-img"
                      src="../../../assets/img/icons/4.webp"
                      width="43"
                      height="41"
                      alt="Icon-HasTech"
                    />
                  </div>
                  <div class="content">
                    <h5 class="title">24 x 7 Online Support</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="shape-group-style1">
            <div class="shape-group-one">
              <img
                src="assets/img/shape/6.webp"
                width="214"
                height="58"
                alt="Image-HasTech"
              />
            </div>
            <div class="shape-group-two">
              <img
                src="assets/img/shape/7.webp"
                width="136"
                height="88"
                alt="Image-HasTech"
              />
            </div>
            <div class="shape-group-three">
              <img
                src="assets/img/shape/8.webp"
                width="108"
                height="74"
                alt="Image-HasTech"
              />
            </div>
            <div class="shape-group-four">
              <img
                src="assets/img/shape/9.webp"
                width="239"
                height="69"
                alt="Image-HasTech"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--== End Feature Area Wrapper ==-->

<div class="container mt-4">
  <!-- Search Bar -->
  <div class="row mb-3">
    <div class="col-md-3"></div>
    <div class="col-md-6">
      <div class="header-middle-align-center">
        <div class="header-search-area">
          <div class="header-searchbox">
            <input
              type="text"
              class="form-control"
              placeholder="Search products..."
              [(ngModel)]="searchTerm"
              (input)="searchProducts()"
            />
            <i
              (click)="searchTerm = ''; searchProducts()"
              *ngIf="searchTerm"
              class="fa fa-times-circle search-icon"
            ></i>
            <button class="btn-submit" type="submit">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Category Chips -->
  <div class="row mb-3">
    <div class="col-md-12">
      <div class="chip-container">
        <div>
          <span
            class="chip"
            [class.selected]="!selectedCategory"
            (click)="clearCategoryFilter()"
          >
            All
          </span>
          <span
            *ngFor="let category of categories"
            class="chip"
            [class.selected]="selectedCategory === category"
            (click)="filterByCategory(category)"
          >
            {{ category }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Product List -->
  <div class="row">
    <ng-container *ngIf="filteredProducts.length > 0; else noProducts">
      <div class="col-md-3 mb-3" *ngFor="let product of filteredProducts">
        <div class="product-item">
          <div class="inner-content">
            <div class="product-thumb">
              <img
                style="min-height: 250px"
                src="{{ product.image }}"
                alt="Image-HasTech"
              />

              <div class="product-action">
                <a (click)="addToCart(product)" class="btn-product-cart"
                  ><i class="fa fa-shopping-cart"></i
                ></a>
                <a
                  [routerLink]="['/products', product.id]"
                  type="button"
                  class="btn-product-quick-view-open"
                >
                  <i class="fa fa-arrows"></i>
                </a>
              </div>
              <a class="banner-link-overlay"></a>
            </div>
            <div class="product-info">
              <h4 class="title">
                <a>{{ product.name }}</a>
              </h4>

              <div style="margin-bottom: 16px" class="avCountry mt-2">
                <span *ngFor="let cou of product.countryOffer">
                  {{ cou }}
                </span>
              </div>

              <div class="row mt-1">
                <div class="col-7">
                  <div *ngIf="product.ranking == 5" class="star-container">
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                  </div>

                  <div *ngIf="product.ranking == 4.5" class="star-container">
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star-half-empty"></i>
                  </div>

                  <div *ngIf="product.ranking == 4" class="star-container">
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star-o"></i>
                  </div>
                </div>
                <div class="col-5">
                  <p class="card-text mb-1">
                    <i style="font-size: 21px" class="fa fa-clock-o"></i>
                    {{ product.cookingTime }} mins.
                  </p>
                </div>
              </div>

              <div class="prices mt-1">
                <span class="price">${{ product.price }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noProducts>
      <div class="no-products">
        <h1>No Products Found</h1>
        <p>
          We couldn't find any products matching your search. Please try again!
        </p>
      </div>
    </ng-template>
  </div>
</div>
